import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { AD_CLICK_CHANNEL_CHANGE_FOR_BI } from './types';

const thunkAction = actionCreator(AD_CLICK_CHANNEL_CHANGE_FOR_BI);

export const adClickChannelChangeThunkAction = ({
  targetChannelId,
  utmSource,
  utmMedium,
  utmCampaign,
  utmTerm,
  utmContent,
}) => (dispatch) =>
  dispatch(
    thunkAction({
      targetChannelId,
      utmSource,
      utmMedium,
      utmCampaign,
      utmTerm,
      utmContent,
    }),
  );
